<template>
    <b-modal :visible="showAdminModal === 'addEditCompany'" size="lg" @hidden="hideModal" :lazy="true">
        <div slot="modal-title">
            <h4 class="modal-title" v-if="item">Изменить компанию {{item.name}}</h4>
            <h4 class="modal-title" v-else>Добавить компанию</h4>
        </div>
        <loading v-if="loading" :size="3" message="Подождите..."></loading>
        <form v-else сlass="form-horizontal">
            <div class="form-group row" :class="{ 'has-danger': $v.newDataItem.name.$error }">
                <label for="item-name" class="col-4 col-md-2 col-form-label">Название</label>
                <div class="col-8 col-md-4">
                    <input class="form-control" type="text" id="item-name"  v-model.trim="newDataItem.name" @input="$v.newDataItem.name.$touch()">
                    <span class="small help-block text-danger" v-if="$v.newDataItem.name.$error">Название обязательно должно быть указано, минимум {{$v.newDataItem.name.$params.minLength.min}} символа</span>
                </div>
            </div>
            <div class="form-group row" :class="{ 'has-danger': $v.newDataItem.sort.$error }">
                <label for="item-sort" class="col-4 col-md-2 col-form-label">Сортировка</label>
                <div class="col-8 col-md-4">
                    <input class="form-control" type="text" id="item-sort"  v-model.trim="newDataItem.sort" @input="$v.newDataItem.sort.$touch()">
                    <span class="small help-block text-danger" v-if="$v.newDataItem.sort.$error">Укажите число</span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-4 col-md-2 col-form-label">Активность компании</label>
                <div class="col-8 col-md-4">
                    <label class="switch switch-lg switch-3d switch-primary ml-1">
                        <input v-model="newDataItem.enabled" type="checkbox" class="switch-input">
                        <span class="switch-label"></span>
                        <span class="switch-handle"></span>
                        <small v-if="newDataItem.enabled">включена</small>
                        <small v-else>выключена</small>
                    </label>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-2 form-control-label">Руководители</label>
                <div class="col-md-10">
                    <multiselect
                            v-model="newDataItem.users"
                            :options="additionalData.users"
                            :searchable="true"
                            :close-on-select="false"
                            :show-labels="false"
                            :multiple="true"
                            placeholder="Руководители не выбран"
                            track-by="id" label="fullname"
                    >
                    </multiselect>
                </div>
            </div>
        </form>
        <div slot="modal-footer">
            <button v-if="!loading" :class="{ 'disabled': $v.newDataItem.$invalid }" :disabled="$v.newDataItem.$invalid" type="button" class="btn btn-success" @click.prevent="beforeUpdateForm">
                <template v-if="item">Сохранить изменения</template>
                <template v-else>Добавить компанию</template>
            </button>
        </div>
    </b-modal>
</template>
<script>
  import { required, minLength, numeric } from 'vuelidate/lib/validators'
  import addCompanyMutate from './../../gql/mutations/AddCompany.graphql'
  import updateCompanyMutate from './../../gql/mutations/UpdateCompany.graphql'
  import getUsersQuery from './../../gql/queries/getUsersForMultiselect.graphql'
  import { mapState, mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  import Multiselect from 'vue-multiselect'
  export default {
    computed: {
      ...mapState({
        showAdminModal: state => state.adminStore.showModal,
        item: state => state.adminStore.editCompany
      })
    },
    watch: {
      showAdminModal: function (val) {
        if (val === 'addEditCompany') {
          this.loading = true
          this.$apollo.query({
            query: getUsersQuery
          }).then((result) => {
            this.loading = false
            this.additionalData = result.data
          })
          if (this.item) {
            this.setNewDataItem()
          } else {
            this.clearData()
          }
        }
      }
    },
    data () {
      return {
        loading: false,
        additionalData: {
          users: []
        },
        newDataItem: {
          id: null,
          name: '',
          sort: 100,
          enabled: true,
          users: []
        }
      }
    },
    methods: {
      setNewDataItem () {
        this.newDataItem = Object.assign({}, this.item)
      },
      beforeUpdateForm () {
        this.$v.newDataItem.$touch()
        if (this.$v.newDataItem.$error) {
          return
        }
        if (this.item) {
          this.updateItem()
        } else {
          this.addItem()
        }
      },
      addItem () {
        this.loading = true
        this.$apollo.mutate({
          mutation: addCompanyMutate,
          variables: {
            name: this.newDataItem.name,
            sort: this.newDataItem.sort,
            enabled: this.newDataItem.enabled,
            users: this.getCollectionIds(this.newDataItem.users)
          }
        }).then((data) => {
          this.loading = false
          this.addToast({
            text: 'Компания успешно добавлена',
            type: 'success',
            dismissAfter: 3000
          })
          this.clearData()
          this.hideModal()
        }).catch((error) => {
          console.error(error)
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.loading = false
        })
      },
      updateItem () {
        this.loading = true
        this.$apollo.mutate({
          mutation: updateCompanyMutate,
          variables: {
            id: this.item.id,
            name: this.newDataItem.name,
            sort: this.newDataItem.sort,
            enabled: this.newDataItem.enabled,
            users: this.getCollectionIds(this.newDataItem.users)
          }
        }).then((data) => {
          this.loading = false
          this.addToast({
            text: 'Компания успешно обновлена',
            type: 'success',
            dismissAfter: 3000
          })
          this.clearData()
          this.hideModal()
        }).catch((error) => {
          console.error(error)
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.loading = false
        })
      },
      getCollectionIds (collection) {
        return collection.map((item) => {
          return item.id
        })
      },
      hideModal () {
        this.$store.commit('SET_ADMIN_EDIT_COMPANY', null)
        this.$store.dispatch('setAdminModal', false)
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      }),
      clearData () {
        this.newDataItem = {
          id: null,
          name: '',
          sort: 100,
          enabled: true,
          users: []
        }
        this.$v.newDataItem.$reset()
      }
    },
    components: {
      Multiselect
    },
    validations: {
      newDataItem: {
        name: {
          required,
          minLength: minLength(2)
        },
        sort: {
          required,
          numeric
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalAdminAddEditCompany.vue?5b29fc20